import counterpart from 'counterpart';

export function getCaseSearchFilterList() {
  let user = JSON.parse(sessionStorage.getItem('state')).auth.user;
  let canExportCase = user.parsedPermissions && user.parsedPermissions.queue && user.parsedPermissions.queue.canExportToSheet ? true : false;
  let role= JSON.parse(sessionStorage.getItem('state')).auth.user.role.key;
  const internalEmployees=['DiMS_INTERNAL_EMPLOYEE'];
  let isInternalUser=false
  if(internalEmployees.findIndex(internalEmp=>internalEmp==role)!=-1){
    isInternalUser = true;
  }
  const __INTERNAL_EMP_CASE_SEARCH__ = 24;
  const __CASE_SEARCH__ = 4;
  return {
    id: isInternalUser?__INTERNAL_EMP_CASE_SEARCH__:__CASE_SEARCH__,
    name: 'Case Search Results',
    headerName: 'Case Search',
    pageId: 'case_search',
    canManageColumns: true,
    dataColumns: [],
    elementIDs: [
      {
        columnKey: 'caseNumber',
        elementId: 'case_number',
      },
      {
        columnKey: 'maskedCardNumber',
        elementId: 'case_first_six_mask-case_last_four_mask',
      },
      {
        columnKey: 'merchantName',
        elementId: 'merchant_name',
      },
      {
        columnKey: 'cardBrandCode',
        elementId: 'case_card_brand',
      },
      {
        columnKey: 'disputeReasonCode',
        elementId: 'case_reason_code',
      },
      {
        columnKey: 'disputeAmount',
        elementId: 'case_from_dispt_amt-case_to_dispt_amt',
      },
      {
        columnKey: 'disputeStatus',
        elementId: 'case_status',
      },
      {
        columnKey: 'acquirerBinIca',
        elementId: 'case_acquirer_bin',
      },
      {
        columnKey: 'acquirerReferenceNumber',
        elementId: 'case_arn',
      },
      {
        columnKey: 'issuerBinIca',
        elementId: 'case_issuer_bin',
      },
      {
        columnKey: 'tranAmount',
        elementId: 'case_trans_amount',
      },
      {
        columnKey: 'transactionDate',
        elementId: 'case_trans_from_date-case_trans_to_date',
      },
      {
        columnKey: 'tranTime',
        elementId: 'case_trans_date',
      },
      {
        columnKey: 'disputeStageName',
        elementId: 'case_type',
      },
      {
        columnKey: 'cardBrandRegionCode',
        elementId: 'case_zone',
      },
      {
        columnKey: 'glCompanyName',
        elementId: 'case_gl_company',
      },
      {
        columnKey: 'codeDescription',
        elementId: 'case_trans_date',
      },
      {
        columnKey: 'cardBrandRegionCode',
        elementId: 'case_status',
      },
      {
        columnKey: 'merchantNumber',
        elementId: 'case_merch_number',
      },
      {
        columnKey: 'dueDate',
        elementId: 'case_from_due_date-case_to_due_date',
      },
      {
        columnKey: 'disputeAmount',
        elementId: 'dispute_amt_from-dispute_amt_to',
      },
      {
        columnKey: 'globalTransactionId',
        elementId: 'global_transaction_id',
      },
      {
        columnKey: "legalName",
        elementId: "legal_name"
      },
      {
        columnKey: "hpyPetroName",
        elementId: "hpy_petro_name"
      },
      {
        columnKey: "mccCode",
        elementId: "mcc_code"
      },
      {
        columnKey: "mcc",
        elementId: "transaction_mcc"
      },
      {
        columnKey: "caseReceivedDate",
        elementId: "case_rcvd_from_date-case_rcvd_to_date"
      },
      {
        columnKey: "posEntryMode",
        elementId: "pos_entry_mode"
      },
      {
        columnKey: "chargebackUsageCode",
        elementId: "chargeback_usage_code"
      },
      {
        columnKey: "merchantDraftChargeback",
        elementId: "merchant_draft_chargeback"
      },
      {
        columnKey: "chargebackReferenceNumber",
        elementId: "chargeback_ref_number"
      },
      {
        columnKey: 'terminalCapabilityCode',
        elementId: 'terminal_capability',
      },
      {
        columnKey: "schemeCaseNumber",
        elementId: "schm_case_nmbr"
      },
	    {
        columnKey: "frontEndVendorDesc",
        elementId: "front_end_vndr_desc"
      },
	    {
        columnKey: "cardBrandRegion",
        elementId: "card_brand_rgn"
      }
    ],
    actions:  [
      {
        title: 'Open Case',
        url: 'landing',
        key: 'OPEN_CASE',
        style: {
          paddingRight: '60px',
          paddingLeft: '0px',
          width: '150px',
        },
      }
    ],
    defaultSort: [
      { key: 'dueDate',
    order: 1,},
    {
      key: 'disputeAmount',
      order: 0,
    }]
  ,
    dateFormat: 'MM/DD/YYYY',
    isExportable: canExportCase,
    pageSize: 25,
  };
}

export function getFilterTranslations() {
  return {
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear All Fields',
    less: 'Less',
    more: 'More',
    save: 'Save',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
    actions: 'Actions',
    active: 'Active',
    addAll: 'Add All',
    apply: 'Apply',
    applyFilterPane: 'Apply',
    backLinkText: 'Back to Reports',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    columns: 'Columns',
    createAFilterContent: 'To select a filter, please create a filter.',
    createAFilterTitle: 'Start by creating a filter',
    currency: 'Currency',
    export: 'Export',
    exporting: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileName: 'Name of file:',
    fileTypesTitle: 'Export As:',
    filterPaneTriggerText: 'Filter',
    filters: 'Filters',
    header: 'Export Data',
    hideAll: 'Hide All',
    inactive: 'Inactive',
    less: 'Less',
    more: 'More',
    next: 'Next',
    prev: 'Prev',
    page: 'Page',
    placeholder: 'Search by Filter Name...',
    preposition: 'of',
    removeAll: 'Remove All',
    save: 'Save',
    savedFilters: 'Saved Searches',
    searchCurrencies: 'Search Currencies',
    shareReport: 'Share Report',
    showAll: 'Show All',
    show25perPage: 'Show 25 per page',
    show50perPage: 'Show 50 per page',
    show75perPage: 'Show 75 per page',
    show100perPage: 'Show 100 per page',
    showingRecords: 'Showing records',
    summaryTitle: 'Summary',
    title: 'Saved Filters',
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
    searchReasonCodePlaceholder: counterpart('globalTranslate.caseSearch.searchReasonCode'),
    reportHierarchy:counterpart('globalTranslate.caseSearch.reportHierarchy'),
  };
}

export function getFilterValues() {
  return [
    {
      id: 1,
      value: 'New',
      valueLabel: 'New ',
      desc: 'English description of New',
      filterValueGroupId: 1,
    },
    {
      id: 2,
      value: 'Open',
      valueLabel: 'Open ',
      desc: 'English description of Open',
      filterValueGroupId: 1,
    },
    {
      id: 3,
      value: 'Closed',
      valueLabel: 'Closed',
      desc: 'English description of Closed',
      filterValueGroupId: 1,
    },
    {
      id: 4,
      value: 'Pended',
      valueLabel: 'Pended',
      desc: 'English description of Pended',
      filterValueGroupId: 1,
    },
  ];
}


export function getValidations(elementTypeName) {
  return [
    {
      id: 'DATE',
      validations: [
        {
          validationRuleKey: 'DATE_RANGE_VALIDATION',
          validationRef: '',
          translatedErrorMessage: 'Start Date must be before End Date. Check the dates and try again.',
          sequence: 0,
        },
      ],
    },
  ].find((queueMetaData) => {
    return queueMetaData.id === elementTypeName;
  });
}

export function getSavedFilters() {
  return [
    {
      id: 929,
      name: 'This_Year',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":"case_trans_date","name":"Original Transaction Date","value":"this_year","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 930,
      name: 'Test203',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 931,
      name: 'last month',
      filterJson: '[{"v1":"last_month","type":"EXACT","id":133,"name":"Original Transaction Date","value":"last_month","values":null},{"v1":"0","v2":"203","type":"BETWEEN","id":134,"name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 932,
      name: 'this month',
      filterJson: '[{"v1":"this_month","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_month","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 933,
      name: 'custom',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 934,
      name: 'trtyy',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 935,
      name: 'test01',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
  ];
}

export function addIconsToGDTableHeadersList(columns) {
  let auth = JSON.parse(sessionStorage.getItem('state')).auth;
  let canViewBookMark=  auth.user && auth.user.parsedPermissions && auth.user.parsedPermissions.case ?auth.user.parsedPermissions.case.canBookmark:false;
  const iconsColumns = columns.find((column) => column.displayType == 'ICON' && column.description == '');
  if (!iconsColumns) {
    canViewBookMark && columns.unshift({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'BookMarkIcon',
      displayOrder: -2,
      isSelected: true,
    });
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'OpenInNewTabIcon',
      displayOrder: 99,
      isSelected: true,
    });
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'FolderIcon',
      displayOrder: 100,
      isSelected: true,
    });
  }

  return columns;
}
